export default __webpack_public_path__ + "static/media/New_Repugnancy_LE.9f492c4d.jpg";